import { siteSchema, type SiteSettings } from '@billing/validation/site';
import type { CanadianTimeZone } from '@billing/validation/timezone';
import type { Organization } from './organization';
import { Province } from '@billing/validation';

export const enum invoicee {
  'site' = 'site',
  'provider' = 'provider',
}

export interface Site {
  id: string;
  name: string;
  address: string;
  city: string;
  province: Province;
  fax: string;
  email: string | null;
  phone: string | null;
  postalCode: string | null;
  region: string;
  status: string;
  description: string;
  proFees: boolean;
  techFees: boolean;
  requiresTariffIcd9: boolean;
  organizationID: string;
  siteNumber: string;
  hospitalCode?: string;
  overhead: number;
  organization?: Organization;
  invoicee: invoicee.site | invoicee.provider;
  invoiceRate: number;
  apiID: string;
  apiSecret: string;
  apiKey: string;
  autoRemit: boolean;
  etransfer: boolean;
  creditCard: boolean;
  cheque: boolean;
  etransferEmail: string | null;
  etransferPasswordRequirement: string | null;
  creditCardPhoneNumber: string | null;
  timezone: CanadianTimeZone;
  allowUploads: boolean;
  settings: SiteSettings;
}

export type FormSite = Omit<Site, 'id'>;

export const isSite = (obj: any): obj is Site => {
  return siteSchema.safeParse(obj).success;
};
